import { Routes } from '@angular/router';

import { StructurePageComponent } from './pages/structure-page/structure-page.component';
import { NotFoundComponent } from './pages/not-found/not-found.component';
import { SignInComponent } from './pages/sign-in/sign-in.component';
import { DashboardComponent } from "./pages/dashboard/dashboard.component";
import { UsersComponent } from "./pages/user/users.component";
import { UserDetailsComponent } from "./pages/user/user-details/user-details.component";
import { UsersListComponent } from "./pages/user/users-list/users-list.component";

import { canActivate } from './apis/auth-guard.service';
import { LockersComponent } from './pages/lockers/lockers.component';
import { LockerDetailsComponent } from './pages/lockers/locker-details/locker-details.component';

export const routes: Routes = [
    { path: 'authentication', component: SignInComponent },
    {
        path: '',
        canActivate: [canActivate],
        component: StructurePageComponent,
        children: [
            { path: '', component: DashboardComponent },
            {
                path: 'users',
                component: UsersComponent,
                children: [
                    {path: '', component: UsersListComponent },
                    {path: 'user-details/:id', component: UserDetailsComponent },
                    {path: 'new-user', component: UserDetailsComponent },
                ]
            },
            { path: 'lockers', component: LockersComponent },
            { path: 'lockers/details/:id', component: LockerDetailsComponent },
            { path: 'lockers/new-locker', component: LockerDetailsComponent },
        ]
    },
    {path: '**', component: NotFoundComponent},
];